import type { PlaceSelfType } from '../../types/Blocks'
import type { BUTTON_DATA, BUTTON_PARAMS } from './types'

import { DEFAULT_MARGIN, DEFAULT_PADDING, DEFAULT_WIDTH } from '../const'

const DEFAULT_BUTTON_PARAMS_DEVICE = () => ({
  hidden: false,
  placeSelf: 'center' as PlaceSelfType,
  width: DEFAULT_WIDTH(),
  padding: DEFAULT_PADDING(),
  margin: DEFAULT_MARGIN(),
})

export const DEFAULT_BUTTON_PARAMS = (): BUTTON_PARAMS => ({
  icon: 'none',
  maxWidth: false,
  tablet: DEFAULT_BUTTON_PARAMS_DEVICE(),
  mobile: DEFAULT_BUTTON_PARAMS_DEVICE(),
  pc: DEFAULT_BUTTON_PARAMS_DEVICE(),
})

export const DEFAULT_BUTTON_DATA = (): BUTTON_DATA => ({
  id: null,
  classes: null,
  type: 'button',
  data: {
    value: 'Lorem Ipsum',
  },
})